import { registerPlugin } from '@capacitor/core';

import type { LogsFileExporterPlugin } from './definitions';

const LogsFileExporter = registerPlugin<LogsFileExporterPlugin>('LogsFileExporter', {
  web: () => import('./web').then(m => new m.LogsFileExporterWeb()),
});

export * from './definitions';
export { LogsFileExporter };
